var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAppVersion } from '../../Config/Environment';
export class Api {
    constructor(baseAddress, abortController) {
        this.jsonHeader = { 'Content-Type': 'application/json' };
        this.setAbortController = (abortController) => {
            this.abortController = abortController;
        };
        this.serviceBase = (baseAddress || window.location.origin) + '/api';
        this.abortController = abortController;
    }
    get(url, q = {}, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.request('GET', url, q, undefined);
            return (options && options.responseHandler(response)) || response.json();
        });
    }
    post(url, data = {}, ignoreResponse, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.request('POST', url, undefined, data);
            if (ignoreResponse) {
                return;
            }
            return (options && options.responseHandler(response)) || response.json();
        });
    }
    put(url, data = {}, ignoreResponse, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.request('PUT', url, undefined, data);
            if (ignoreResponse) {
                return;
            }
            return (options && options.responseHandler(response)) || response.json();
        });
    }
    delete(url, data = {}, ignoreResponse, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.request('DELETE', url, undefined, data);
            if (ignoreResponse) {
                return;
            }
            return (options && options.responseHandler(response)) || response.json();
        });
    }
    /* Generic request method */
    request(method, url, q = {}, data) {
        return __awaiter(this, void 0, void 0, function* () {
            let queryString = this.buildQueryString(q);
            var resultPromise = () => fetch(this.serviceBase + url + (queryString ? '?' + queryString : ''), {
                method: method,
                body: data ? JSON.stringify(Object.assign({}, data)) : null,
                headers: this.appendHeaders(this.jsonHeader),
                signal: this.abortController ? this.abortController.signal : undefined,
            }).catch(e => {
                console.log('Catch error: ' + e);
                return null;
            });
            return this.executeRequest(resultPromise);
        });
    }
    executeRequest(response) {
        return __awaiter(this, void 0, void 0, function* () {
            var result = yield response();
            this.checkStatus(result);
            return result;
        });
    }
    checkStatus(response) {
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        else {
            let errorMessage = response.statusText;
            let error = new Error(errorMessage);
            error.response = response;
            throw error;
        }
    }
    appendHeaders(jsonHeader = {}) {
        const headers = Object.assign({}, jsonHeader);
        headers['pragma'] = 'no-cache';
        headers['cache-control'] = 'no-cache';
        const appVersion = getAppVersion();
        if (appVersion) {
            headers['client-application-version'] = appVersion;
        }
        return headers;
    }
    buildQueryString(data) {
        return Object.keys(data)
            .filter(x => data[x] !== undefined)
            .map((key) => {
            if (data[key] instanceof Array) {
                let param = '';
                let array = data[key];
                for (let i = 0; i < array.length; i++) {
                    param += key + '=' + encodeURI(array[i]);
                    if (i < array.length - 1) {
                        param += '&';
                    }
                }
                return param;
            }
            return key + '=' + data[key];
        })
            .join('&');
    }
}
Api.emptyResponseHandler = (response) => Promise.resolve();
